import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskLines, Reveal } from "./Motion";
import { useT } from "@/i18n";

export const AboutTeaser = () => {
  const t = useT();
  return (
    <section id="chi-siamo" className="bg-[#F7F5F0] px-5 py-24 text-[#121110] sm:px-8 lg:py-32" data-testid="about-teaser">
      <div className="mx-auto max-w-[1500px]">
        <div className="max-w-4xl">
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#6E685E]">{t("teaser.kicker", "Dal 1905 · Famiglia Emma")}</p>
          <MaskLines
            className="mt-6 font-display text-4xl font-bold leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl"
            lines={[t("cs.h1", "Cinque generazioni,"), <em key="b" className="font-serif font-normal text-[#C26D38]">{t("cs.h2", "un solo nome.")}</em>]}
          />
          <Reveal delay={0.15} className="mt-8 max-w-xl text-base leading-relaxed text-[#4D4943] sm:text-lg">
            {t("teaser.text", "Scultori, restauratori d'arte sacra, pionieri del lamellare e dell'X-LAM nel Sud Italia: oltre un secolo di legno tramandato di padre in figlio.")}
          </Reveal>
          <Reveal delay={0.25} className="mt-10">
            <Link to="/chi-siamo" className="inline-flex items-center gap-3 rounded-full bg-[#121110] px-7 py-4 font-mono text-xs uppercase tracking-[0.2em] text-[#F7F5F0] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-[#2A2622]" data-testid="about-teaser-link">
              {t("teaser.cta", "Scopri la nostra storia")} <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
